import { useQuery } from '@tanstack/react-query';
import type AgentApiAiJobSearchRunsItem from '@/types/serializers/AgentApiAiJobSearchRunsItem';
import { POLLING_INTERVAL_MS } from '../constants';

/** AI求人検索ランの状態をポーリング取得するクエリ */
export default function useFetchAiJobSearchRun(runId: number | null) {
  return useQuery({
    queryKey: ['aiJobSearchRun', runId],
    enabled: runId !== null,
    queryFn: async (): Promise<AgentApiAiJobSearchRunsItem> => {
      const response = await fetch(`/agent/api/ai_job_search_runs/${runId}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('検索ランの取得に失敗しました');
      }

      const data: AgentApiAiJobSearchRunsItem = await response.json();
      return data;
    },
    // queued/processing の間はポーリング、それ以外は停止
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === 'queued' || status === 'processing') {
        return POLLING_INTERVAL_MS;
      }
      return false;
    },
    refetchOnWindowFocus: false,
  });
}
